// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"5cf66de7","114":"36cc36ca","560":"1a39b4b4","637":"efad5e7b","655":"b882e5f0","673":"c18c5c7d","760":"895b247f","764":"caa8dd12","820":"c3eca161","859":"88218e3d","965":"1f0db0b0"}[chunkId] + ".chunk.js";
};